import React from 'react'
import {Grid, FormControl, InputLabel, TextField, FormHelperText} from '@material-ui/core'
export default function WEmailField({data, onChange}) {
  const validateEmail = inputText => {
    if (inputText.value === '' || inputText.value === undefined) {
      return false
    }
    let mailformat = /^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([\\.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)+$/i
    if (mailformat.test(inputText.value)) {
      return false
    } else {
      return true
    }
  }
  return (
    <FormControl fullWidth variant="outlined" className="ap-textfield" style={{width: 320}}>
      <TextField
        id="outlined-adornment-amount"
        value={data.value}
        onChange={e => {
          onChange(e, 'value', data)
        }}
        type={'email'}
        labelWidth={60}
        label={data.name}
        variant="outlined"
        InputLabelProps={{
          shrink: true,
        }}
        error={validateEmail(data)}
        helperText={validateEmail(data) ? 'invalid email format' : ''}
      />
      <FormHelperText>{!data.is_required ? 'optional' : ''}</FormHelperText>
    </FormControl>
  )
}
